import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Store in localStorage for offline functionality
    const messages = JSON.parse(localStorage.getItem('contactMessages') || '[]');
    messages.push({ ...formData, date: new Date().toISOString() });
    localStorage.setItem('contactMessages', JSON.stringify(messages));
    setSubmitted(true);
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      
      <main className="flex-1">
        {/* Page Header */}
        <div className="bg-white border-b mb-6">
          <div className="max-w-7xl mx-auto px-4 py-8">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800">Contact Us</h1>
            <p className="text-gray-600 mt-2">Get in touch with our team</p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 pb-12">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Contact Info */}
            <div className="bg-white rounded-lg p-6 md:p-8 border border-gray-200">
              <h2 className="text-xl font-bold text-gray-800 mb-6">Get In Touch</h2>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="bg-[#fed900]/10 p-3 rounded-lg">
                    <Mail className="text-[#fed900]" size={20} />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-800">Email</h3>
                    <a href="mailto:julekharay89@gmail.com" className="text-[#fed900] hover:underline text-sm">
                      julekharay89@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-[#fed900]/10 p-3 rounded-lg">
                    <Phone className="text-[#fed900]" size={20} />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-800">Phone</h3>
                    <a href="tel:+16265157813" className="text-[#fed900] hover:underline text-sm">
                      +16265157813
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-[#fed900]/10 p-3 rounded-lg">
                    <MapPin className="text-[#fed900]" size={20} />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-800">Address</h3>
                    <p className="text-gray-600 text-sm">1797 NW 110th Terrace</p>
                    <p className="text-gray-600 text-sm">Coral Springs - 33071-5153</p>
                    <p className="text-gray-600 text-sm">United States (US)</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t">
                <h3 className="font-medium text-gray-800 mb-3">Contact Person</h3>
                <p className="text-gray-600 text-sm"><strong>Name:</strong> PRASHANT SARASWAT</p>
                <p className="text-gray-600 text-sm"><strong>Developer:</strong> haray</p>
                <p className="text-gray-600 text-sm"><strong>Legal Name:</strong> Michelle Rachel Blumenkranz</p>
              </div>

              <div className="mt-6 pt-6 border-t">
                <h3 className="font-medium text-gray-800 mb-3">Business Hours</h3>
                <p className="text-gray-600 text-sm">Monday - Friday: 9:00 AM - 6:00 PM EST</p>
                <p className="text-gray-600 text-sm">Saturday: 10:00 AM - 4:00 PM EST</p>
                <p className="text-gray-600 text-sm">Sunday: Closed</p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-lg p-6 md:p-8 border border-gray-200">
              <h2 className="text-xl font-bold text-gray-800 mb-6">Send a Message</h2>
              
              {submitted ? (
                <div className="text-center py-8">
                  <div className="bg-[#fed900]/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Send className="text-[#fed900]" size={24} />
                  </div>
                  <h3 className="text-lg font-medium text-gray-800 mb-2">Message Saved!</h3>
                  <p className="text-gray-600 text-sm">Your message has been saved locally. We'll get back to you soon!</p>
                  <button
                    onClick={() => setSubmitted(false)}
                    className="mt-4 text-[#fed900] hover:underline text-sm"
                  >
                    Send another message
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fed900] focus:border-transparent"
                      placeholder="Your name"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fed900] focus:border-transparent"
                      placeholder="your@email.com"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                    <input
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fed900] focus:border-transparent"
                      placeholder="Subject"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows={4}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fed900] focus:border-transparent resize-none"
                      placeholder="Your message..."
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-[#fed900] text-white py-3 rounded-lg font-medium hover:bg-[#8B1E3F] transition-colors flex items-center justify-center gap-2"
                  >
                    <Send size={18} />
                    Send Message
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactPage;
